/**
 * Kombiniert Datum ('YYYY-MM-DD') und Uhrzeit ('HH:mm') zu einem ISO-8601-datetime
 * fuer das pm-api (zod .datetime()). Bewusst auf UTC fixiert (kein Date/dayjs),
 * damit der eingegebene Kalendertag + die Uhrzeit stabil bleiben (keine
 * Zeitzonen-Verschiebung). Ohne Datum -> null. Ohne Uhrzeit -> Mitternacht.
 */
export function combineDateTimeToIso(date: string | null | undefined, time?: string | null): string | null {
  if (!date) return null;
  const t = (time && /^\d{2}:\d{2}$/.test(time)) ? time : '00:00';
  return `${date}T${t}:00.000Z`;
}

/**
 * Zerlegt ein ISO-8601-datetime in Datum + Uhrzeit (rohe Komponenten, ohne
 * Zeitzonen-Konvertierung — passend zu combineDateTimeToIso).
 */
export function splitIsoDateTime(iso: string | null | undefined): { date: string; time: string } {
  if (!iso) return { date: '', time: '' };
  const [datePart, rest] = iso.split('T');
  const time = rest ? rest.slice(0, 5) : '';
  return { date: datePart ?? '', time };
}
